/**
 * Affiliate destinations live on each pillar page's content object
 * (see data/pages/*.ts → affiliateUrl). They are intentionally empty:
 * paste the affiliate URL there and every CTA on that page becomes a link.
 */
export const AFFILIATE_DISCLOSURE =
  'Este enlace puede contener un enlace de afiliado. Si realizas una compra a través de él, CreceElite puede recibir una comisión, sin costo adicional para ti.'
